import { render, staticRenderFns } from "./importShipment.vue?vue&type=template&id=1e22941c&scoped=true&"
import script from "./importShipment.vue?vue&type=script&lang=js&"
export * from "./importShipment.vue?vue&type=script&lang=js&"
import style0 from "./importShipment.vue?vue&type=style&index=0&id=1e22941c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e22941c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VFlex,VForm,VLayout,VProgressLinear,VSpacer})
